import { withInstall } from "../utils/index.mjs";
import _Badge from "./Badge.mjs";
const Badge = withInstall(_Badge);
var stdin_default = Badge;
export {
  Badge,
  stdin_default as default
};
